var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStats = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1569 9.92938C18.1569 9.36844 18.6116 8.9137 19.1725 8.9137C19.7335 8.9137 20.1882 9.36844 20.1882 9.92938V21.1019C20.1882 21.6629 19.7335 22.1176 19.1725 22.1176C18.6116 22.1176 18.1569 21.6629 18.1569 21.1019V9.92938Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0784 7.89801C13.0784 7.33706 13.5332 6.88232 14.0941 6.88232C14.6551 6.88232 15.1098 7.33706 15.1098 7.89801V21.1019C15.1098 21.6629 14.6551 22.1176 14.0941 22.1176C13.5332 22.1176 13.0784 21.6629 13.0784 21.1019V7.89801Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.9764C8 12.4155 8.45474 11.9608 9.01569 11.9608C9.57663 11.9608 10.0314 12.4155 10.0314 12.9764V21.1019C10.0314 21.6629 9.57663 22.1176 9.01569 22.1176C8.45474 22.1176 8 21.6629 8 21.1019V12.9764Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2353 16.0235C23.2353 15.4626 23.69 15.0078 24.251 15.0078C24.8119 15.0078 25.2667 15.4626 25.2667 16.0235V21.1019C25.2667 21.6629 24.8119 22.1176 24.251 22.1176C23.69 22.1176 23.2353 21.6629 23.2353 21.1019V16.0235Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStats, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stats.7f392816.svg";
export { ForwardRef as ReactComponent };